<div class="header-sticky-container">
  <div class="header-container">
    <div class="header-bg"></div>
    <img
      style="pointer-events: none"
      class="header-logo"
      [ngClass]="'header-logo-' + currentLanguage"
      [appImageSprite]="currentLanguage + '_menu_full_color_logo@2x'"
      [params]="lang_icons"
    />
  </div>
</div>
